"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateTransformGroupingByEntity = void 0;
const rc_js_util_1 = require("rc-js-util");
const swap_buffer_layout_1 = require("./swap-buffer-layout");
/**
 * @public
 * An update grouping corresponding to {@link ICompositeGraphicsComponent.groupUpdatesByEntity} with transforms.
 */
class UpdateTransformGroupingByEntity {
    constructor(graphicsComponents, componentRenderers, transformComponents, transformRenderers) {
        this.graphicsComponents = graphicsComponents;
        this.componentRenderers = componentRenderers;
        this.transformComponents = transformComponents;
        this.transformRenderers = transformRenderers;
        DEBUG_MODE && rc_js_util_1._Debug.runBlock(() => {
            const allEqualLength = rc_js_util_1._Equality.allEqual([
                graphicsComponents.length,
                componentRenderers.length,
                transformComponents.length,
                transformRenderers.length,
            ]);
            rc_js_util_1._Debug.assert(allEqualLength, "input length mismatch");
        });
        this.reuseTransform = this.getReuseTransforms(graphicsComponents, transformComponents);
    }
    drawUpdateGroup(entities, updateArg) {
        const graphicsComponents = this.graphicsComponents;
        const entityRenderers = this.componentRenderers;
        const transformComponents = this.transformComponents;
        const transformRenderers = this.transformRenderers;
        const reuseTransforms = this.reuseTransform;
        for (let i = 0, iEnd = entities.length; i < iEnd; ++i) {
            const entity = entities[i];
            if (entity.isFiltered) {
                continue;
            }
            for (let j = 0, jEnd = graphicsComponents.length; j < jEnd; ++j) {
                const graphicsComponent = graphicsComponents[j];
                const componentRenderer = entityRenderers[j];
                const transformComponent = transformComponents[j];
                const transformRenderer = transformRenderers[j];
                const entityBufferLayout = componentRenderer.sharedState.entityBuffers.getLayout(entity, graphicsComponent.transform.groupId);
                // if the entity has buffers, use them
                (0, swap_buffer_layout_1.swapBufferLayout)(graphicsComponent, entityBufferLayout);
                // only perform the transform if the update group changes
                if (transformComponent != null && !reuseTransforms[j]) {
                    DEBUG_MODE && rc_js_util_1._Debug.assert(transformRenderer != null, "precondition fail");
                    if (graphicsComponent.transform.isTransformRequired(entity, updateArg)) {
                        /* eslint-disable @typescript-eslint/no-non-null-assertion */
                        transformRenderer.onBeforeDraw();
                        graphicsComponent.transform.setOutputBuffers(entity, transformRenderer);
                        transformComponent.performTransform(entity, transformRenderer, updateArg);
                        transformRenderer.onAfterDraw();
                        /* eslint-enable @typescript-eslint/no-non-null-assertion */
                    }
                }
                // gc update
                componentRenderer.onBeforeDraw();
                graphicsComponent.onBeforeUpdate(componentRenderer, updateArg);
                graphicsComponent.update(entity, componentRenderer, updateArg);
                componentRenderer.onAfterDraw();
                // swap back
                (0, swap_buffer_layout_1.swapBufferLayout)(graphicsComponent, entityBufferLayout);
            }
        }
    }
    getReuseTransforms(graphicsComponents, transformComponents) {
        const reuseTransforms = new Uint8Array(transformComponents.length);
        const lastTransformGroup = new Map();
        for (let i = 0, iEnd = transformComponents.length; i < iEnd; ++i) {
            const transform = transformComponents[i];
            const graphicsComponent = graphicsComponents[i];
            if (transform == null) {
                reuseTransforms[i] = 0;
                continue;
            }
            if (lastTransformGroup.get(transform) === graphicsComponent.transform.groupId) {
                reuseTransforms[i] = 1;
            }
            else {
                reuseTransforms[i] = 0;
                lastTransformGroup.set(transform, graphicsComponent.transform.groupId);
            }
        }
        return reuseTransforms;
    }
}
exports.UpdateTransformGroupingByEntity = UpdateTransformGroupingByEntity;
//# sourceMappingURL=update-transform-grouping-by-entity.js.map